module.exports = __webpack_public_path__ + "img/circle-1.c9d1066b.png";